// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems_NavigationItems__1fnFX","dropdownItems":"NavigationItems_dropdownItems__31gls"};